import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Button, Input } from "reactstrap";
import axios from "axios";
import { URL } from "../api";
import axiosInstance from "../Request";

const LeadListComment = ({ customerId, loanId, leadId }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");


  const toggleModal = async () => {
    if (!modalOpen) {
      await fetchComments();
    }
    setModalOpen(!modalOpen);
  };

  

  const fetchComments = async () => {
    setLoading(true);
    try {
      const [res2, res3] = await Promise.all([
        axiosInstance.get(URL.GET_COMMENTS, {
          params: {
            customer_id: customerId,
            lead_id: leadId,
            comment_type: 2,
          },
        }),
        axiosInstance.get(URL.GET_COMMENTS, {
          params: {
            customer_id: customerId,
            lead_id: leadId,
            comment_type: 3,
          },
        }),
      ]);

      const comments2 = Array.isArray(res2.data) ? res2.data : [];
      const comments3 = Array.isArray(res3.data) ? res3.data : [];
      const combinedComments = [...comments2, ...comments3];

      combinedComments.sort(
        (a, b) => new Date(b.create_date) - new Date(a.create_date)
      );

      setComments(combinedComments);
    } catch (error) {
      console.error("Error fetching comments:", error);
      setComments([]);
    } finally {
      setLoading(false);
    }
  };
const handleAddComment = async () => {
  const user_id = localStorage.getItem("user_id");

  if (!newComment.trim() || !user_id) {
    console.error("Missing comment text or user_id");
    return;
  }

  const payload = {
    customer_id: customerId,
    lead_id: leadId,
    loan_id: loanId || null,
    comment: newComment.trim(),
    comment_type: 3,
    comment_by: user_id,
  };

  try {
    const res = await axiosInstance.post(URL.ADD_COMMENTS, payload);
    setResponseMessage(res.data.message || "Comment Added Successfully"); 
    setNewComment("");
    setIsAdding(false);
    await fetchComments();
    setTimeout(() => setResponseMessage(""), 3000);
  } catch (error) {
    console.error("Error adding comment:", error);
    setResponseMessage("Error adding comment"); 
    setTimeout(() => setResponseMessage(""), 3000); 
  }
};


  return (
    <>
      <span
        onClick={toggleModal}
        style={{
          color: "#007bff",
          textDecoration: "underline",
          cursor: "pointer",
          marginLeft: "10px",
          fontWeight: "500",
        }}
      >
        comment
      </span>

      <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
        <ModalHeader
          toggle={toggleModal}
          style={{ backgroundColor: "#f1f1f1", fontWeight: "600" }}
        >
          Comments - Customer ID: {customerId}, Loan ID: {loanId}, Lead ID: {leadId}
        </ModalHeader>
        <ModalBody style={{ backgroundColor: "#fafafa" }}>
          <div style={{ marginBottom: "16px" }}>
            {!isAdding ? (
              <Button color="primary" size="sm" onClick={() => setIsAdding(true)}>
                Add Comment
              </Button>
            ) : (
              <div style={{ marginBottom: "12px" }}>
                <Input
                  type="textarea"
                  placeholder="Enter comment..."
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                  rows={3}
                  style={{ marginBottom: "8px" }}
                />
                <div>
                  <Button
                    color="success"
                    size="sm"
                    onClick={handleAddComment}
                    style={{ marginRight: "8px" }}
                  >
                    Submit
                  </Button>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => {
                      setIsAdding(false);
                      setNewComment("");
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </div>
            {responseMessage && (
            <p style={{ color: responseMessage.includes("Success") ? "green" : "red", fontWeight: "500" }}>
                {responseMessage}
            </p>
            )}

          {loading ? (
            <p style={{ fontStyle: "italic", color: "#666" }}>Loading...</p>
          ) : comments.length === 0 ? (
            <p style={{ fontStyle: "italic", color: "#999" }}>No comments found.</p>
          ) : (
            comments.map((comment) => (
              <div
                key={comment.id}
                style={{
                  padding: "12px 16px",
                  marginBottom: "16px",
                  backgroundColor: "#fff",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    marginBottom: "8px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  Date: <span style={{ color: "#555" }}>{comment.create_date}</span> &nbsp; | &nbsp;
                  By: <span style={{ color: "#555" }}>{comment.commented_by_username || "N/A"}</span> &nbsp; | &nbsp;
                  {comment.comment_type_value || "-"} &nbsp; | &nbsp;
                  Status: <span style={{ color: "#555" }}>{comment.status_value || "-"}</span>
                </div>
                <div style={{ fontSize: "15px", lineHeight: "1.5", color: "#444" }}>
                  <strong>Comment:</strong> {comment.comment}
                </div>
              </div>
            ))
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default LeadListComment;
